import React, { useState, useEffect } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import AddressLine from '@components/Addresses/AddressLine';
import NwSlickSlider from '@components/Gui/NwSlickSlider';

const AddressSelectContainer = styled.div`
    padding: 2rem 1.5rem;
    .slick-arrow {
        top: 3rem;
    }
    .slick-track {
        .slick-slide {
            padding: 0 0.5rem;
            box-sizing: border-box;

            .connection-name {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                gap: 0.5rem;
                h4 {
                    margin: 0;
                }
                margin-bottom: 0.5rem;
            }
        }
    }
    .no-addresses {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: ${(props) => props.theme.DangerColor};
        text-transform: uppercase;
        gap: 1rem;

        p {
            margin: 0;
        }
        span {
            font-size: ${(props) => props.theme.FontSizeLg};
        }
    }
    .address-line-content {
        word-break: break-word;
        white-space: pre-wrap;
    }
`;

const Slide = styled.div`
    position: relative;
    padding: 0.5rem 0.5rem 2.5rem;
    min-height: 10rem;
    cursor: pointer;
    border: ${(props) => (props.$selected ? `2px solid ${props.theme.PrimaryColor}` : props.theme.DefaultBorder)};
    border-radius: 0.5rem;
`;

const AddressesByProject = ({ projectId, eventData, onChange }) => {
    const [addresses, setAddresses] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);

    const getProjectAddresses = async () => {
        const prjaddresses = await Axios.get(`/projects/geteventaddresses/${projectId}`);
        setAddresses(prjaddresses);
        return null;
    };

    useEffect(() => {
        getProjectAddresses();
    }, [projectId]);

    const handleSelect = (address, index) => {
        setSelectedIndex(index);
        onChange(address);
    };

    return (
        <AddressSelectContainer>
            <NwSlickSlider slidesToShow={3} slidesToScroll={3} variableWidth={false} adaptiveHeight>
                {addresses.map((address, index) => (
                    <Slide
                        $selected={selectedIndex === index}
                        key={index}
                        index={index}
                        onClick={() => handleSelect(address, index)}
                    >
                        <AddressLine address={address} inLocationSelector />
                    </Slide>
                ))}
            </NwSlickSlider>
        </AddressSelectContainer>
    );
};

export default AddressesByProject;
